const mcpTokenRemoval = () => {
	const url = new URL(window.location.href);
	url.searchParams.delete('mcp_token');
	window.history.replaceState({}, document.title, url);
};

export default mcpTokenRemoval;
